import axios from 'axios';
import MUIDataTable, { MUIDataTableOptions } from 'mui-datatables'
import { Fragment, useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { getHeaderForAxios, getUserData } from '../../common/getLocalStorageData';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { FaRegEdit, FaRegPlusSquare, FaTrashAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../../interfaces/redux';
import { PROFILE_AWARDLIST, SIDE_MENU_PROFILE } from '../../constant/menuAndProfile';

interface IData {
    index?: number;
    name?: string;
    value?: string;
    start_date?: string;
    end_date?: string;
    already_winner_count?: number;
    winner_count?: number;
    deal_index?: number;
}
interface IAwardList {
    // dealList: Array<any>,
    dealDetail: Array<any>,
    selectedDeal: any,
    onSaveAwardDetail: (data: any) => void,
    openSelectOption: (open: boolean) => void
    // changeActiveDeal: (arg0: string, arg1: string) => void,
}
export const AwardList = (props: IAwardList) => {
    const [dealDetailState, setDealDetail] = useState<Array<any>>([]);
    const [results, setResults] = useState<IData[]>([]);
    const [finalData, setFinalData] = useState<(string | number | undefined)[][]>([]);
    const [awardFlag, setAwardFlag] = useState(false);
    const [open, setOpen] = useState(false);
    const [awardId, setAwardId] = useState("");
    const [editDealIndex, setEditDealIndex] = useState(-1);
    const [awardOffer, setAwardOffer] = useState("");
    const [awardStartDate, setAwardStartDate] = useState("");
    const [awardEndDate, setAwardEndDate] = useState("");
    const [currentAwardDetail, setCurrentAwardDetail] = useState<any>({})
    const [responseMessage, setResponseMessage] = useState({
        "message": "",
        "type": ""
    })
    const [currentDealDetail, setCurrentDealDetail] = useState<any>({})
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLanguage = globalState?.selectedLang;
    useEffect(() => {
        if (props?.dealDetail) {
            setDealDetail(props?.dealDetail)
        }
    }, [props?.dealDetail])
    useEffect(() => {
        if (props?.dealDetail && props?.selectedDeal) {
            props?.dealDetail?.forEach((dData: any) => {
                if (dData?.uuid === props?.selectedDeal) {
                    setCurrentDealDetail(dData)
                }
            })
        }
    }, [props?.dealDetail, props?.dealDetail.length, props?.selectedDeal])

    const setAwardDetail = (dealDetail: any, awardIndex: number, awardId: string = "") => {
        setEditDealIndex(awardIndex)
        const dealAwardDetail: any = {
            "deal_uuid": dealDetail?.deal_uuid,
            "award_value": dealDetail?.value,
            "start_date": dealDetail?.start_date,
            "end_date": dealDetail?.end_date,
            "status": dealDetail?.status || 1
        }
        if (dealDetail?.value) {
            setAwardOffer(dealDetail?.value)
        }
        if (dealDetail?.start_date) {
            const isoString = new Date(dealDetail?.start_date).toISOString();
            setAwardStartDate(isoString.substring(0, isoString.indexOf("T") + 6))
        }
        if (dealDetail?.end_date) {
            const isoString = new Date(dealDetail?.end_date).toISOString();
            setAwardEndDate(isoString.substring(0, isoString.indexOf("T") + 6))
        }
        if (awardId) {
            dealAwardDetail['award_id'] = awardId;
            setAwardId(awardId);
        }
        setCurrentAwardDetail(dealAwardDetail)
        setAwardFlag(!awardFlag);
        setOpen(true);
    }

    const columns = [
        { name: PROFILE_AWARDLIST[selectedLanguage].no, options: { filter: false, fullWidth: true } },
        { name: PROFILE_AWARDLIST[selectedLanguage].deal, options: { filter: true } },
        { name: PROFILE_AWARDLIST[selectedLanguage].offer, options: { filter: true } },
        { name: PROFILE_AWARDLIST[selectedLanguage].start_date, options: { filter: true } },
        { name: PROFILE_AWARDLIST[selectedLanguage].end_date, options: { filter: true } },
        { name: PROFILE_AWARDLIST[selectedLanguage].offer_distribute, options: { filter: true } },
        { name: PROFILE_AWARDLIST[selectedLanguage].total_winner, options: { filter: true } },
        {
            name: PROFILE_AWARDLIST[selectedLanguage].action,
            options: {
                filter: false,
                customBodyRender: (value: any, tableMeta: { rowData: any; }, updateValue: any) => {
                    return (
                        <Fragment>
                            {dealDetailState[value]?.award_id ?
                                <Fragment>
                                    <FaRegEdit className="mr-3 theme-green font-16 pointer" onClick={() => {
                                        setAwardDetail(dealDetailState[value], value, dealDetailState[value]?.award_id)
                                    }} />
                                    <FaTrashAlt className="text-gray font-16 pointer" onClick={() => {
                                        onDeleteAwardDetail(dealDetailState[value], value)
                                    }}
                                    />
                                </Fragment>
                                :
                                <FaRegPlusSquare className="theme-green font-16 pointer" onClick={() => {
                                    // editButton(tableMeta.rowData)
                                    setAwardDetail(dealDetailState[value], value)
                                }}
                                />
                            }
                        </Fragment>
                    );
                }
            }
        }
    ];
    const resetEditAwardData = () => {
        setOpen(false);
        setEditDealIndex(-1);
        setAwardId("")
        setCurrentAwardDetail({})
        setAwardOffer("")
        setAwardStartDate("")
        setAwardEndDate("")
        setAwardFlag(!awardFlag);
    }
    const options: MUIDataTableOptions = {
        filter: true,
        filterType: "dropdown",
        responsive: 'simple',
        jumpToPage: false,
        fixedSelectColumn: false,
        fixedHeader: false,
        pagination: false,
        selectableRows: 'none',
        onTableChange: (action, state) => {
            // console.log(action);
            // console.dir(state);
        }
    };
    useEffect(() => {
        if (dealDetailState) {
            let data: any[] = [];
            let array: (string | number | undefined)[][];
            dealDetailState?.map((dealData: any, index: number) => {
                let startDate = "";
                let endDate = "";
                if (dealData?.start_date) {
                    startDate = new Date(dealData?.start_date)?.toISOString().replace('T', ' ').replace('Z', ' ');
                }
                if (dealData?.end_date) {
                    endDate = new Date(dealData?.end_date)?.toISOString().replace('T', ' ').replace('Z', ' ');
                }
                data.push({
                    index: index + 1,
                    name: dealData?.match_title + " - " + dealData?.tp_name,
                    value: dealData?.value,
                    start_date: startDate,
                    end_date: endDate,
                    already_winner_count: dealData?.already_winner_count,
                    winner_count: dealData?.winner_count,
                    deal_index: index
                })
            })
            setResults(data)
            if (data) {
                if (data.length) {
                    array = data?.map(result => [result.index, result.name, result.value || "-", result.start_date || '-', result?.end_date || '-', result?.already_winner_count, result?.winner_count, result?.deal_index]);
                    // data = array;
                    setFinalData(array)
                }
            }
        }
    }, [dealDetailState, props?.selectedDeal?.deal_uuid])
    const saveAwardDetail = (data: object) => {
        // console.log("hellloo", data)
        const userId = getUserData();
        let finalData = currentAwardDetail?.award_id ? { ...data, "id": currentAwardDetail.award_id, "award_type": 2, 'user_uuid': userId } : { ...data, "award_type": 2, 'user_uuid': userId }
        axios.post(process.env.REACT_APP_API_URL + '/sponsor/addUpdateAwardDetail', finalData, { headers: getHeaderForAxios() })
            .then(function (response) {
                // handle success
                if (response.data && response.data.status === "success") {
                    if (response.data.success) {
                        if (editDealIndex !== -1) {
                            let dealData = [...dealDetailState]
                            dealData[editDealIndex] = { ...dealData[editDealIndex], ...response.data.success }
                            setDealDetail(dealData)
                        }
                        else {
                            let dealData = [...dealDetailState]
                            dealData.push(response.data.success)
                            setDealDetail(dealData)
                        }
                        resetEditAwardData();
                    }
                    if (response.data?.message) {
                        setResponseMessage({ message: response.data?.message, type: "success" });
                        setTimeout(() => {
                            setResponseMessage({ message: "", type: "" });
                        }, 10000);
                    }
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
    }

    const onDeleteAwardDetail = (awardDetail: any, awardIndex) => {
        const userId = getUserData();
        if (awardDetail) {
            let finalData = { "id": awardDetail.award_id, "deal_uuid": awardDetail.deal_uuid, "status": 2, 'user_uuid': userId }
            axios.post(process.env.REACT_APP_API_URL + '/sponsor/addUpdateAwardDetail', finalData, { headers: getHeaderForAxios() })
                .then(function (response) {
                    // handle success
                    if (response.data && response.data.status === "success") {
                        if (awardIndex !== -1) {
                            let dealData = [...dealDetailState]
                            if (response.data?.success) {
                                dealData[awardIndex] = { ...dealData[awardIndex], ...response.data?.success }
                            }
                            setDealDetail(dealData);
                            setResponseMessage({ message: "Award remove successfully", type: "success" });
                            setTimeout(() => {
                                setResponseMessage({ message: "", type: "" });
                            }, 10000);
                        }
                    }
                    resetEditAwardData();
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                    resetEditAwardData();
                })
        }
    }

    const handleClose = () => {
        resetEditAwardData();
    }
    const handleSave = () => {
        let data = { ...currentAwardDetail }
        if (awardOffer) {
            data['award_value'] = awardOffer;
        }
        if (awardStartDate) {
            data['start_date'] = new Date(awardStartDate)?.toISOString().replace('T', ' ').replace('Z', ' ');
        }
        if (awardEndDate) {
            data['end_date'] = new Date(awardEndDate)?.toISOString().replace('T', ' ').replace('Z', ' ');
        }
        saveAwardDetail(data)
    }
    return (
        <Fragment >
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle className='d-flex align-self-center justify-content-center'>{awardId && editDealIndex !== -1 ? PROFILE_AWARDLIST[selectedLanguage].dialog_edit_title : PROFILE_AWARDLIST[selectedLanguage].dialog_add_title}</DialogTitle>
                <DialogContent key={awardFlag ? "true" : "false"}>
                    <Row className='py-2 mx-3 mx-md-5'>
                        <Col sm={12} className=''>
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label={PROFILE_AWARDLIST[selectedLanguage].dialog_match_name}
                                    id="pac-match-title"
                                    defaultValue={dealDetailState[editDealIndex]?.match_title}
                                    disabled
                                />
                            </Row>
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label={PROFILE_AWARDLIST[selectedLanguage].dialog_team_player_name}
                                    id="pac-tp-title"
                                    defaultValue={dealDetailState[editDealIndex]?.tp_name}
                                    disabled
                                />
                            </Row>
                            {/* <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label="Team/Player Name"
                                    id="pac-tp-title"
                                    defaultValue={dealDetailState[editDealIndex]?.tp_name}
                                    disabled
                                />
                            </Row>
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label="Team/Player Name"
                                    id="pac-tp-title"
                                    defaultValue={dealDetailState[editDealIndex]?.tp_name}
                                    disabled
                                />
                            </Row> */}
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label={PROFILE_AWARDLIST[selectedLanguage].dialog_offer}
                                    id="pac-award-offer"
                                    value={awardOffer}
                                    defaultValue={awardOffer}
                                    onChange={(e) => setAwardOffer(e.target.value)}
                                />
                            </Row>
                            <Row>
                                <Col className='pl-0 pr-0 pr-md-2' sm={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="pac-award-start-date"
                                        label={PROFILE_AWARDLIST[selectedLanguage].dialog_offer_start_date}
                                        type="datetime-local"
                                        margin="dense"
                                        variant="outlined"
                                        value={awardStartDate}
                                        defaultValue={awardStartDate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(e) => setAwardStartDate(e.target.value)}
                                    />
                                </Col>
                                <Col className='pr-0 pl-0 pl-md-2' sm={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="pac-award-start-date"
                                        label={PROFILE_AWARDLIST[selectedLanguage].dialog_offer_end_date}
                                        type="datetime-local"
                                        margin="dense"
                                        variant="outlined"
                                        value={awardEndDate}
                                        defaultValue={awardEndDate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(e) => setAwardEndDate(e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions>
                    <Row className='mx-5 mb-2 w-100 d-flex align-self-center justify-content-center'>
                        <Button onClick={handleSave}
                            variant="dark" className='py-1 rounded-sm' autoFocus>
                            {SIDE_MENU_PROFILE[selectedLanguage].save}
                        </Button>
                        <Button onClick={handleClose}
                            variant="primary" className='ml-2 py-1 rounded-sm' autoFocus>
                            {SIDE_MENU_PROFILE[selectedLanguage].close}
                        </Button>
                    </Row>
                </DialogActions>
            </Dialog>
            <div className='right-side-header-main'>
                <div className='right-side-header'>{PROFILE_AWARDLIST[selectedLanguage].award_list}</div>
            </div>
            <hr />
            <Row>
                <Col sm={12} className="d-flex align-items-center justify-content-end pl-0 pr-0">
                    <div className="material-dropdown-select">
                        {/* <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic">Select Stastics</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {props?.dealList && props?.dealList?.map((data: any, index: number) =>
                                    <Dropdown.Item eventKey={index.toString()} active={data.main_deal_uuid === props.selectedDeal?.main_deal_uuid ? true : false} onClick={() => { props.changeActiveDeal(data.main_deal_uuid, data?.deal_list[0]?.deal_uuid) }}>{data?.match_title}</Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown> */}
                        <Button
                            onClick={() => { props.openSelectOption(true) }}
                            variant="primary" className='btn btn-dark theme-background-dark-black theme-white rounded-sm py-2 font-16' autoFocus>
                            {PROFILE_AWARDLIST[selectedLanguage].toggle_data}
                        </Button>
                    </div>
                </Col>
            </Row>
            {responseMessage.message ? (
                <div className='login-form-div'>
                    <div
                        className={
                            responseMessage.type === "success"
                                ? "form-response success mb-0 mt-2"
                                : "form-response error mb-0 mt-2"
                        }
                    >
                        {responseMessage.message}
                    </div>
                </div>
            ) : null}
            <Row className='pt-2'>
                <Col sm={12} className='react-table-kitchen-wrapper theme-dark-black'>
                    <div className="table-wrapper" style={{ 'flexGrow': 1 }}>
                        {finalData ?
                            // <ThemeProvider theme={createTheme()}>
                            <MUIDataTable
                                title={(currentDealDetail?.match_title ? currentDealDetail?.match_title + " - " : "") + (currentDealDetail?.tp_name || "")}
                                data={finalData}
                                columns={columns}
                                options={options}
                            />
                            // </ThemeProvider>
                            : null
                        }
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
}
